import { render, staticRenderFns } from "./DiseaseProcessedList.vue?vue&type=template&id=0027d3f9&scoped=true&"
import script from "./DiseaseProcessedList.vue?vue&type=script&lang=js&"
export * from "./DiseaseProcessedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027d3f9",
  null
  
)

export default component.exports